import { RecentlyViewed } from './recently-viewed-products.js';

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str == null ? '' : String(str);
  return div.innerHTML;
}

class RecentlyViewedProductsElement extends HTMLElement {
  connectedCallback() {
    const currentHandle = this.dataset.currentHandle || '';
    const maxProducts = parseInt(this.dataset.max || '4', 10);

    if (currentHandle) {
      RecentlyViewed.addProduct(currentHandle);
    }

    const handles = RecentlyViewed.getProducts()
      .filter((handle) => handle && handle !== currentHandle)
      .slice(0, maxProducts);

    if (handles.length === 0) {
      return;
    }

    Promise.all(
      handles.map((handle) =>
        fetch(`/products/${handle}.js`)
          .then((res) => (res.ok ? res.json() : null))
          .catch(() => null)
      )
    ).then((products) => {
      const validProducts = products.filter(Boolean);
      if (validProducts.length === 0) return;

      const list = this.querySelector('[data-recently-viewed-list]');
      if (!list) return;

      let currencyCode = 'EUR';
      try {
        currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      } catch (e) {
        currencyCode = 'EUR';
      }
      const locale = document.documentElement.lang || 'de-DE';

      list.innerHTML = validProducts
        .map((product) => {
          const image = product.featured_image || (product.images && product.images[0]) || '';
          let priceText = '';
          try {
            priceText = (product.price / 100).toLocaleString(locale, { style: 'currency', currency: currencyCode });
          } catch (e) {
            priceText = '';
          }
          return (
            '<div class="resource-list__item recently-viewed__item">' +
              '<a href="' + product.url + '" class="recently-viewed__link">' +
                '<span class="recently-viewed__media">' +
                  (image ? '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="300" height="300">' : '') +
                '</span>' +
                '<span class="recently-viewed__title">' + escapeHtml(product.title) + '</span>' +
                '<span class="price recently-viewed__price">' + priceText + '</span>' +
              '</a>' +
            '</div>'
          );
        })
        .join('');

      const wrapper = this.closest('[data-recently-viewed-wrapper]');
      if (wrapper) {
        wrapper.style.display = '';
      }
    });
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProductsElement);
}
